import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';

/**
 * Class responsible for manage the API calls and data request of the App
 */
export class FundingReservesService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };
    /**
     * Instantiates a new ClientService
     */
    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    public async fundingReserves(
        dealerId: string,
        brandCode: string,
        endOfMonthStartDate: string,
        endOfMonthEndDate: string,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/fundingReserves`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                dealerId,
                brandCode,
                endOfMonthStartDate,
                endOfMonthEndDate,
                getDetails: true,
                jwtToken: permissionsToken,
            },
        };
        return this.client.sendRequest(request);
    }

    public abort() {
        this.client.controller.abort();
    }
}
